module.exports = "/_next/static/images/video_id_7180451533455363374-70c8218ec2721d0705e97b895a2a36a3.jpg";